import fetch from '../utils/fetch';
import {ApiURL} from './config';
import moment from 'moment';


class ProjectApi {

    static getStates(){
        return fetch(`${ApiURL}/project/states`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static getAll(){
        return fetch(`${ApiURL}/project`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static getProject(projectId){
        return fetch(`${ApiURL}/project/${projectId}`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static getProjectStats(projectId){
        return fetch(`${ApiURL}/project/${projectId}/stats`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static getMyProjects(){
        return fetch(`${ApiURL}/user/project`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static store(data) {
        Date.prototype.toJSON = function(){ return moment(this).format('Y-MM-DD'); };
        return fetch(`${ApiURL}/project`, {
            method: 'POST',
            body: JSON.stringify(data),
            'Content-Type': 'application/json'
        });
    }

    static update(data) {
        Date.prototype.toJSON = function(){ return moment(this).format('Y-MM-DD'); };
        return fetch(`${ApiURL}/project/${data.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            'Content-Type': 'application/json'
        });
    }

    static addMember(projectId, userId){
        return fetch(`${ApiURL}/project/${projectId}/user`, {
            method: 'POST',
            body: JSON.stringify({id:userId}),
            'Content-Type': 'application/json'
        });
    }

    static removeMember(projectId, userId){
        return fetch(`${ApiURL}/project/${projectId}/user/${userId}`, {
            method: 'DELETE',
            'Content-Type': 'application/json'
        });
    }
}

export default ProjectApi;


/** WEBPACK FOOTER **
 ** ./src/api/projectApi.js
 **/